<template>
	<div class="about mt-10 mx-64 px-64">
		<rp-card class="flex text-center px-32 pb-10">
			<h1 class="text-3xl mt-2 mb-8">Me contacter</h1>
			<rp-alert
				v-if="mailSent"
				level="success"
				@close="mailSent = false"
			>
				Le mail de contact a bien été envoyé
			</rp-alert>
			<form @submit.prevent="sendMail">
				<input
					v-model="email"
					aria-label="Email"
					name="email"
					type="email"
					required
					class="mb-4 appearance-none rounded-none w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-rypert-primary focus:border-rypert-primary focus:z-10 sm:text-sm sm:leading-5"
					placeholder="Email"
				/>
				<textarea
					v-model="text"
					aria-label="Votre message"
					name="message"
					rows="10"
					required
					class="appearance-none rounded-none w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-rypert-primary focus:border-rypert-primary focus:z-10 sm:text-sm sm:leading-5"
					placeholder="Votre message"
				></textarea>
				<input
					name="emailTo"
					type="hidden"
					:value="emailTo"
				/>
				<rp-button
					class="mt-4 w-full"
					:disabled="sending"
				>
					Envoyer
				</rp-button>
			</form>
		</rp-card>
	</div>
</template>

<script>
import RpCard from "../components/RpCard";
import RpButton from "../components/RpButton";
import RpAlert from "../components/RpAlert";
import emailjs from "emailjs-com";

export default {
	name: "About",
	components: {
		RpCard,
		RpButton,
		RpAlert
	},
	data() {
		return {
			email: "",
			text: "",
			sending: false,
			mailSent: false
		};
	},
	computed: {
		emailTo() {
			return process.env.VUE_APP_EMAIL;
		}
	},
	methods: {
		sendMail(e) {
			this.sending = true;
			emailjs
				.sendForm("gmail", "contact", e.target, process.env.VUE_APP_MAILJS)
				.then(
					result => {
						this.sending = false;
						this.mailSent = true;
						this.email = "";
						this.text = "";
						console.log("SUCCESS!", result.status, result.text);
					},
					error => {
						this.sending = false;
						console.log("FAILED...", error);
					}
				);
		}
	}
};
</script>

<style></style>
